// ============================================================
// main.js — メインエントリポイント
//
// Vite でバンドルされます。
// サイト共通の初期化処理をここに記述してください。
// ============================================================

import "../css/main.css";
import initializeViewport from "./initializeViewport.js";
import { initBackToTopButton } from "./backToTop.js";
import { smoothScrollToHash, setupAnchorLinks } from "./smoothScroll.js";
import { accordion } from "./accordion.js";
import { setAsideNavActiveLink } from "./setAsideNavActiveLink.js";
import { initializeModal } from "./modal.js";
import { mainvisualAnimation } from "./mainvisualAnimation.js";
import { scrollHidden } from "./scrollHidden.js";
import { initSwiper } from "./swiper.js";

if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

// ---- 初期化 ----
initializeViewport();
initBackToTopButton();
accordion();
setAsideNavActiveLink();
initializeModal();
mainvisualAnimation();
scrollHidden();
initSwiper();

// ---- スムーススクロール ----
smoothScrollToHash(70);
setupAnchorLinks(70);
